import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Focus from "@/components/site/Focus";
import Footer from "@/components/site/Footer";
import BackgroundFX from "@/components/site/BackgroundFX";
import ScrollToHash from "@/components/site/ScrollToHash";
import SmoothScroll from "@/components/site/SmoothScroll";
import { Manifesto, Marquee } from "@/components/site/Manifesto";

import PortfolioPage from "@/pages/PortfolioPage";
import ContactPage from "@/pages/ContactPage";
import PortfolioSector from "@/pages/PortfolioSector";

const Landing = () => (
  <main className="relative bg-[#F7F6F3] text-[#1A1A1A] overflow-x-hidden">
    <BackgroundFX />
    <div className="relative z-10">
      <Navbar />
      <Hero />
      <Manifesto />
      <Marquee />
      <Focus />
      <Footer />
    </div>
  </main>
);

function App() {
  return (
    <div className="App bg-[#F7F6F3] min-h-screen">
      <BrowserRouter>
        <SmoothScroll />
        <ScrollToHash />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/portfolio/:slug" element={<PortfolioSector />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="light"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            border: "1px solid rgba(19,98,7,0.12)",
            color: "#1A1A1A",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
